/** Port of i18n/en-us/index.js */
export default {
  failed: 'Action failed',
  success: 'Action was successful',
} as const
